export default 'newsletter'
